// Write your code here
import './index.css'

const TabItem = props => {
  const {tabDetails, onClickTab, isActive} = props

  const {tabId, displayText} = tabDetails

  const onClick = () => {
    onClickTab(tabId)
  }

  const tabClass = isActive ? 'active-tab' : 'normal-tab'

  return (
    <li className="tab-item">
      <button className={tabClass} type="button" onClick={onClick}>
        {displayText}
      </button>
    </li>
  )
}

export default TabItem
